/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamsPackageDto
 */
export interface CreateUpdateExamsPackageDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateExamsPackageDto
     */
    registrationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    authorUID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    type?: CreateUpdateExamsPackageDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    mode?: CreateUpdateExamsPackageDtoModeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateExamsPackageDto
     */
    number?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamsPackageDto
     */
    sendCompanyEmail?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamsPackageDto
     */
    healthcareFacilityId?: string | null;
}


/**
 * @export
 */
export const CreateUpdateExamsPackageDtoTypeEnum = {
    Single: 'Single',
    Mulitiple: 'Mulitiple'
} as const;
export type CreateUpdateExamsPackageDtoTypeEnum = typeof CreateUpdateExamsPackageDtoTypeEnum[keyof typeof CreateUpdateExamsPackageDtoTypeEnum];

/**
 * @export
 */
export const CreateUpdateExamsPackageDtoModeEnum = {
    Exams: 'Exams',
    Normalization: 'Normalization'
} as const;
export type CreateUpdateExamsPackageDtoModeEnum = typeof CreateUpdateExamsPackageDtoModeEnum[keyof typeof CreateUpdateExamsPackageDtoModeEnum];


/**
 * Check if a given object implements the CreateUpdateExamsPackageDto interface.
 */
export function instanceOfCreateUpdateExamsPackageDto(value: object): value is CreateUpdateExamsPackageDto {
    return true;
}

export function CreateUpdateExamsPackageDtoFromJSON(json: any): CreateUpdateExamsPackageDto {
    return CreateUpdateExamsPackageDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamsPackageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamsPackageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'registrationDate': json['registrationDate'] == null ? undefined : (new Date(json['registrationDate'])),
        'authorUID': json['authorUID'] == null ? undefined : json['authorUID'],
        'type': json['type'] == null ? undefined : json['type'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'number': json['number'] == null ? undefined : json['number'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'sendCompanyEmail': json['sendCompanyEmail'] == null ? undefined : json['sendCompanyEmail'],
        'healthcareFacilityId': json['healthcareFacilityId'] == null ? undefined : json['healthcareFacilityId'],
    };
}

export function CreateUpdateExamsPackageDtoToJSON(value?: CreateUpdateExamsPackageDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'registrationDate': value['registrationDate'] == null ? undefined : ((value['registrationDate'] as any).toISOString()),
        'authorUID': value['authorUID'],
        'type': value['type'],
        'mode': value['mode'],
        'number': value['number'],
        'companyId': value['companyId'],
        'sendCompanyEmail': value['sendCompanyEmail'],
        'healthcareFacilityId': value['healthcareFacilityId'],
    };
}

